import './card-testimonial.scss';

export default () => {

};
